const collapseWhitespace = (value) => String(value ?? '').replace(/\s+/g, ' ').trim();

export const normalizeRelationTitleKey = (title) => collapseWhitespace(title).toLowerCase();

/**
 * @param {Array<{ id: *, title?: string }>|null|undefined} relationTypes
 * @returns {Record<string, *>}
 */
export const buildRelationTypeIdByTitleKey = (relationTypes) =>
    Object.fromEntries(
        (relationTypes ?? [])
            .filter((entry) => entry?.title != null && String(entry.title).trim() !== '')
            .map((entry) => [normalizeRelationTitleKey(entry.title), entry.id]),
    );

/**
 * @param {*} raw
 * @returns {string}
 */
export const resolveRelationTitleFromCell = (raw) => {
    if (raw == null) {
        return '';
    }
    if (typeof raw === 'string') {
        return collapseWhitespace(raw);
    }
    return collapseWhitespace(raw?.title);
};
